<template>
  <div class="app-single-top-up-success">
    <slot name="txtBefore">
    </slot>

    <dyn-slot :slot-data="slotData">
      <slot name="txtSuccess">Vielen Dank! Ihr Guthaben wurde um {{slotData.formattedAmount}} aufgeladen.</slot>
    </dyn-slot>

    <Stepper
      :show-next="false"
      @prev="prev()"
      :show-logout="true"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
    <LogOut v-if="showLogout"></LogOut>

    <slot name="txtAfter">
    </slot>
  </div>
</template>

<script>

import Stepper from '../../../../generic/Stepper.vue'
import { mapGetters, mapMutations } from 'vuex'
import processSteps from '../../../../../mixins/processSteps'
import { stepName as previousStep } from './AmountSelector.vue'
import price from '@/mixins/price'
import slotProxy from '../../../../../mixins/slotProxy'
import LogOut from '../../Authentication/LogOut/LogOut.vue'

export const stepName = 'success'

export default {
  name: 'SingleTopUpSuccess',
  components: { LogOut, Stepper },
  mixins: [
    processSteps(stepName, previousStep, stepName),
    price,
    slotProxy()
  ],
  computed: {
    ...mapGetters('topUp/single', [
      'amount'
    ]),
    formattedAmount: function () {
      return this.price(this.amount)
    },
    slotData: function () {
      return {
        formattedAmount: this.formattedAmount
      }
    }
  },
  props: {
    showLogout: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapMutations('topUp/single', [
      'reset'
    ]),
    prev () {
      this.reset()
    }
  }
}
</script>
